import Vue from 'vue'
import Router from 'vue-router'
import { newRouter } from "./router";
Vue.use(Router)

export const constantRouterMap = [
  {
    path : '/test/canvas',
    name : 'canvas',
    component: resolve => import('@/view/test/canvas').then(module => { resolve(module) })
  },
  {
    path : '/test/start',
    name : 'canvasStart',
    component: resolve => import('@/view/test/start').then(module => { resolve(module) })
  },
  {
    path : '/test/next',
    name : 'canvasNext',
    component: resolve => import('@/view/test/next').then(module => { resolve(module) })
  },
  {
    path : '/activity/showInfo',
    name : 'showInfo',
    component: resolve => import('@/view/activity/showInfo').then(module => { resolve(module) })
  },
  {
    path: '/',
    redirect: '/trainingCourse/index/2/1574969319409807401'
  },
  {
    path: '/login',
    name: 'Login',
    component: resolve => import('@/view/login/index').then(module => { resolve(module) })
  },
  {
    path: '/wxLogin',
    name: 'wxLogin',
    component: resolve => import('@/view/login/wx-login').then(module => { resolve(module) })
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    component: resolve => import('@/view/login/user-info').then(module => { resolve(module) })
  },
  {
    path:'/Education/story/:id',
    name:'story',
    component: resolve => import('@/view/Education/story').then(module=>{ resolve(module) })
  },  
  {
    path: '/login2',
    name: 'Login2',
    component: resolve => import('@/view/login/login').then(module => { resolve(module) })
  },
  {
    path: '/tylogin',
    name: 'tylogin',
    component: resolve => import('@/view/login/tylogin').then(module => { resolve(module) })
  },
  {
   // path: '/person',
      path: '/person/:userId',

    name: 'person',
    // meta: {
    //   title: '个人空间',
    //   isChildren: false
    // },
    component: resolve => import('@/view/person/index').then(module => { resolve(module) }),
    // redirect: '/person/index',
    // children: [
      // {
      //   path: 'person',
      //   name: 'person',
      //   meta: {
      //     title: '首页',
      //     isChildren: false
      //   },
      //   component: resolve => import('@/view/home/index').then(module => { resolve(module) })
      // },
    // ]
  },
  // 新增加页面路由
  ...newRouter,
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '首页',
      isChildren: false
    },
    component: resolve => import('@/view/layout/layout').then(module => { resolve(module) }),
    redirect: '/home/index',
    children: [
      {
        path: 'index',
        name: 'index',
        meta: {
          title: '首页',
          isChildren: false
        },
        // component: resolve => import('@/view/home/index').then(module => { resolve(module) })
        component: resolve => import('@/view/pages/home/home').then(module => { resolve(module) })
      },
      {
        path: 'OBOR',
        name: 'OBOR',
        meta: {
          title: '一带一路',
          isChildren: false
        },
        // component: resolve => import('@/view/home/index').then(module => { resolve(module) })
        component: resolve => import('@/view/OBOR/OBOR').then(module => { resolve(module) })
      },{
        path: 'eduDetails/:educationId',
        name: 'eduDetails',
        meta: {
          title: '学历认证详情',
          isChildren: false
        },
        component: resolve => import('@/view/home/education/eduDetails').then(module => { resolve(module) })
      },{
        path: 'eduApply',
        name: 'eduApply',
        meta: {
          title: '学历认证报名',
          isChildren: false
        },
        component: resolve => import('@/view/home/education/eduApply').then(module => { resolve(module) })
      },{
        path: 'curriculum/:courseId',
        name: 'curriculum',
        meta: {
          title: '课程',
          isChildren: false
        },
        component: resolve => import('@/view/home/curriculum/curriculum').then(module => { resolve(module) })
      },{
        path: 'sysCurriculum/:courseId',
        name: 'sysCurriculum',
        meta: {
          title: '课程设置',
          isChildren: false
        },
        component: resolve => import('@/view/home/sysCurriculum/sysCurriculum').then(module => { resolve(module) })
      }
    ]
  },
  {
    path: '/courseView',
    name: 'courseView',
    meta: {
      title: '首页',
      isChildren: false
    },
    component: resolve => import('@/view/CourseSystem/CourseIndex/index').then(module => { resolve(module) }),
    redirect: '/courseView/new',
    children: [
      {
        path: 'new/:languaListId/:moduleId',
        name: 'new',
        meta: {
          title: '公告',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/new/new').then(module => { resolve(module) })
      },
      {
        path: 'courseNewDetails/:languaListId/:moduleId/:newId',
        name: 'courseNewDetails',
        meta: {
          title: '公告详情',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/new/newDetails').then(module => { resolve(module) })
      },
      {
        path: 'seatwork/:languaListId/:moduleId',
        name: 'seatwork',
        meta: {
          title: '作业',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/seatwork/seatwork').then(module => { resolve(module) })
      },
      {
        path: 'newList/:languaListId/:moduleId',
        name: 'newList',
        meta: {
          title: '所有公告',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/new/newList').then(module => { resolve(module) })
      },
      {
        path: 'course/:languaListId/:moduleId',
        name: 'course',
        meta: {
          title: '课程',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/course/course').then(module => { resolve(module) })
      },
      {
        path: 'courseContent/:languaListId/:moduleId/:chapterId',
        name: 'courseContent',
        meta: {
          title: '课程内容',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/course/courseContent').then(module => { resolve(module) })
      },
      {
        path: 'seatworkContent/:languaListId/:moduleId/:operationId',
        name: 'seatworkContent',
        meta: {
          title: '作业内容',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/seatwork/seatworkContent').then(module => { resolve(module) })
      },
      {
        path: 'QA/:languaListId/:moduleId',
        name: 'QA',
        meta: {
          title: '讨论区',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/QA/QA').then(module => { resolve(module) })
      },
      {
        path: 'discussionRule/:languaListId/:moduleId',
        name: 'discussionRule',
        meta: {
          title: '讨论规则',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysQA/discussionRule').then(module => { resolve(module) })
      },
      {
        path: 'newDiscussion/:languaListId/:moduleId/:bbsId',
        name: 'newDiscussion',
        meta: {
          title: '发起讨论',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/QA/addDiscussion').then(module => { resolve(module) })
      },
      {
        path: 'QAList/:languaListId/:moduleId/:bbsModuleId',
        name: 'QAList',
        meta: {
          title: '管理讨论区',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/QA/sysQAList').then(module => { resolve(module) })
      },      
      {
        path: 'reply/:languaListId/:moduleId/:bbsModuleId/:bbsId',
        name: 'reply',
        meta: {
          title: '讨论区回复',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/QA/reply').then(module => { resolve(module) })
      },
      {
        path: 'score/:languaListId/:moduleId',
        name: 'score',
        meta: {
          title: '课程评价',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/score/score').then(module => { resolve(module) })
      },
      {
        path: 'questionnaire/:languaListId/:moduleId',
        name: 'questionnaire',
        meta: {
          title: '课程评价',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/score/questionnaire').then(module => { resolve(module) })
      },
      {
        path: 'quesWork/:languaListId/:moduleId/:operationId',
        name: 'quesWork',
        meta: {
          title: '课程评价',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/score/quesWork').then(module => { resolve(module) })
      },
      {
        path: 'scoretionnaire/:languaListId/:moduleId/:operationId',
        name: 'scoretionnaire',
        meta: {
          title: '问卷调查',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/score/scoretionnaire').then(module => { resolve(module) })
      },
      {
        path: 'exam/:languaListId/:moduleId',
        name: 'exam',
        meta: {
          title: '考试',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/exam/exam').then(module => { resolve(module) })
      },
      {
        path: 'examContent/:languaListId/:moduleId/:operationId',
        name: 'examContent',
        meta: {
          title: '考试',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/exam/examContent').then(module => { resolve(module) })
      }
    ]

  },
  {
    path: '/CourseSystem',
    name: 'CourseSystem',
    meta: {
      title: '首页',
      isChildren: false
    },
    component: resolve => import('@/view/CourseSystem/index').then(module => { resolve(module) }),
    redirect: '/CourseSystem/new',
    children: [
      {
        path: 'newDetails/:languaListId/:moduleId/:newId',
        name: 'newDetails',
        meta: {
          title: '公告详情',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysNew/newDetails').then(module => { resolve(module) })
      },
      {
        path: 'sysNew/:languaListId/:moduleId',
        name: 'sysNew',
        meta: {
          title: '管理发布公告',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysNew/sysNew').then(module => { resolve(module) })
      },
      {
        path: 'sysNewList/:languaListId/:moduleId',
        name: 'sysNewList',
        meta: {
          title: '管理更多公告',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysNew/sysNewList').then(module => { resolve(module) })
      },
      {
        path: 'sysEditNew/:languaListId/:moduleId/:newId',
        name: 'sysEditNew',
        meta: {
          title: '公告编辑',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysNew/sysEditNew').then(module => { resolve(module) })
      },
      {
        path: 'sysCourse/:languaListId/:moduleId',
        name: 'sysCourse',
        meta: {
          title: '课程管理',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysCourse/sysCourse').then(module => { resolve(module) })
      },
      {
        path: 'sysCourseContent/:languaListId/:moduleId/:chapterId',
        name: 'sysCourseContent',
        meta: {
          title: '课程管理',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysCourse/sysCourseContent').then(module => { resolve(module) })
      },
      {
        path: 'sysSeatwork/:languaListId/:moduleId',
        name: 'sysSeatwork',
        meta: {
          title: '作业管理',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysSeatwork/sysSeatwork').then(module => { resolve(module) })
      },
      {
        path: 'sysSeatworkRecord/:languaListId/:moduleId',
        name: 'sysSeatworkRecord',
        meta: {
          title: '作业提交记录',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysSeatwork/sysSeatworkRecord').then(module => { resolve(module) })
      },
      {
        path: 'sysSeatworkAnswer/:languaListId/:moduleId/:annalId',
        name: 'sysSeatworkAnswer',
        meta: {
          title: '做题记录详情',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysSeatwork/sysSeatworkAnswer').then(module => { resolve(module) })
      },
      {
        path: 'sysQuesAnswer/:languaListId/:moduleId/:annalId',
        name: 'sysQuesAnswer',
        meta: {
          title: '问卷详情',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysScore/sysQuesAnswer').then(module => { resolve(module) })
      },
      {
        path: 'sysAddSeatwork/:languaListId/:moduleId/:operationId',
        name: 'sysAddSeatwork',
        meta: {
          title: '添加作业',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysSeatwork/sysAddSeatwork').then(module => { resolve(module) })
      },
      {
        path: 'seatworkAnswer',
        name: 'seatworkAnswer',
        meta: {
          title: '作业答案',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/seatwork/seatworkAnswer').then(module => { resolve(module) })
      },
      {
        path: 'sysQA/:languaListId/:moduleId',
        name: 'sysQA',
        meta: {
          title: '管理讨论区',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysQA/sysQA').then(module => { resolve(module) })
      },
      {
        path: 'sysDiscussionRule/:languaListId/:moduleId',
        name: 'sysDiscussionRule',
        meta: {
          title: '讨论规则',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysQA/discussionRule').then(module => { resolve(module) })
      },
      {
        path: 'sysQAList/:languaListId/:moduleId/:bbsModuleId',
        name: 'sysQAList',
        meta: {
          title: '讨论区列表',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysQA/sysQAList').then(module => { resolve(module) })
      },
      {
        path: 'sysReply/:languaListId/:moduleId/:bbsModuleId/:bbsId',
        name: 'sysReply',
        meta: {
          title: '讨论区回复',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysQA/sysReply').then(module => { resolve(module) })
      },
      // {
      //   path: 'QA/:languaListId/:moduleId',
      //   name: 'QA',
      //   meta: {
      //     title: '管理讨论区',
      //     isChildren: false
      //   },
      //   component: resolve => import('@/view/CourseSystem/CourseView/QA/QA').then(module => { resolve(module) })
      // },
      {
        path: 'sysClassQAList/:languaListId/:moduleId/:bbsModuleId',
        name: 'sysClassQAList',
        meta: {
          title: '课程讨论区列表',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysQA/sysClassQAList').then(module => { resolve(module) })
      },
      {
        path: 'sysKnowledgePointQAList/:languaListId/:moduleId/:bbsModuleId',
        name: 'sysKnowledgePointQAList',
        meta: {
          title: '知识点讨论区列表',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysQA/sysKnowledgePointQAList').then(module => { resolve(module) })
      },
      {
        path: 'sysStudentQAList/:languaListId/:moduleId/:bbsModuleId',
        name: 'sysStudentQAList',
        meta: {
          title: '学生讨论区',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysQA/sysStudentQAList').then(module => { resolve(module) })
      },
      {
        path: 'sysTeacherQAList',
        name: 'sysTeacherQAList',
        meta: {
          title: '教师答疑区',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysQA/sysTeacherQALis').then(module => { resolve(module) })
      },
      {
        path: 'addDiscussion/:languaListId/:moduleId/:bbsId',
        name: 'addDiscussion',
        meta: {
          title: '发起讨论',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysQA/addDiscussion').then(module => { resolve(module) })
      },
      {
        path: 'fileDownload',
        name: 'fileDownload',
        meta: {
          title: '课件下载',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/download/fileDownload').then(module => { resolve(module) })
      },
      {
        path: 'courseEvaluation',
        name: 'courseEvaluation',
        meta: {
          title: '课件下载',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseView/courseEvaluation/courseEvaluation').then(module => { resolve(module) })
      },
      {
        path: 'sysMember/:languaListId/:moduleId',
        name: 'sysMember',
        meta: {
          title: '成员管理',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysMember/sysMember').then(module => { resolve(module) })
      },
      {
        path: 'sysScore/:languaListId/:moduleId',
        name: 'sysScore',
        meta: {
          title: '课程评价',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysScore/sysScore').then(module => { resolve(module) })
      },
      {
        path: 'sysQuestionnaire/:languaListId/:moduleId',
        name: 'sysQuestionnaire',
        meta: {
          title: '问卷调查',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysScore/sysQuestionnaire').then(module => { resolve(module) })
      },
      {
        path: 'sysQuesRecord/:languaListId/:moduleId',
        name: 'sysQuesRecord',
        meta: {
          title: '问卷调查提交记录',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysScore/sysQuesRecord').then(module => { resolve(module) })
      },
      {
        path: 'sysOverview/:languaListId/:moduleId',
        name: 'sysOverview',
        meta: {
          title: '问卷调查',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/overview/sysOverview').then(module => { resolve(module) })
      },
      {
        path: 'sysCountQues/:languaListId/:moduleId/:operationId',
        name: 'sysCountQues',
        meta: {
          title: '问卷统计',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysScore/sysCountQues').then(module => { resolve(module) })
      },
      {
        path: 'sysCountScore/:languaListId/:moduleId/:operationId',
        name: 'sysCountScore',
        meta: {
          title: '课程评价统计',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysScore/sysCountScore').then(module => { resolve(module) })
      },
      {
        path: 'sysCountSeatwork/:languaListId/:moduleId/:operationId',
        name: 'sysCountSeatwork',
        meta: {
          title: '课程作业统计',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysSeatwork/sysCountSeatwork').then(module => { resolve(module) })
      },
      {
        path: 'sysQuesAddWork/:languaListId/:moduleId/:operationId',
        name: 'sysQuesAddWork',
        meta: {
          title: '问卷作业添加',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysScore/sysQuesAddWork').then(module => { resolve(module) })
      },
      {
        path: 'sysGrouping/:languaListId/:moduleId',
        name: 'sysGrouping',
        meta: {
          title: '小组',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/grouping/grouping').then(module => { resolve(module) })
      },
      {
        path: 'syscorrect/:languaListId/:moduleId',
        name: 'syscorrect',
        meta: {
          title: '练习批改',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/syscorrect/syscorrect').then(module => { resolve(module) })
      },
      {
        path: 'syscorrectList/:languaListId/:moduleId/:operationId',
        name: 'syscorrectList',
        meta: {
          title: '练习批改详细',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/syscorrect/syscorrectSList').then(module => { resolve(module) })
      },
      {
        path: 'sysCountcorrect/:languaListId/:moduleId/:operationId',
        name: 'sysCountcorrect',
        meta: {
          title: '练习统计',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/syscorrect/sysCountcorrect').then(module => { resolve(module) })
      },
      {
        path: 'sysCorrectAnswer/:languaListId/:moduleId/:annalId',
        name: 'sysCorrectAnswer',
        meta: {
          title: '练习批改',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/syscorrect/sysCorrectAnswer').then(module => { resolve(module) })
      },
      {
        path: 'sysExam/:languaListId/:moduleId',
        name: 'sysExam',
        meta: {
          title: '考试列表',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysExam/sysExamList').then(module => { resolve(module) })
      },
      {
        path: 'sysExamWork/:languaListId/:moduleId/:operationId',
        name: 'sysExamWork',
        meta: {
          title: '考试题目编辑',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysExam/sysExamWork').then(module => { resolve(module) })
      },
      {
        path: 'sysExamCount/:languaListId/:moduleId/:operationId',
        name: 'sysExamCount',
        meta: {
          title: '考试统计',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysExam/sysCountExam').then(module => { resolve(module) })
      },
      {
        path: 'sysExamRecord/:languaListId/:moduleId',
        name: 'sysExamRecord',
        meta: {
          title: '考试提交记录',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysExam/sysExamRecord').then(module => { resolve(module) })
      },
      {
        path: 'sysExamkAnswer/:languaListId/:moduleId/:annalId',
        name: 'sysExamkAnswer',
        meta: {
          title: '考试批改',
          isChildren: false
        },
        component: resolve => import('@/view/CourseSystem/CourseManagement/sysExam/sysExamkAnswer').then(module => { resolve(module) })
      },
    ]
  },
  {
    path: '/system',
    name: 'system',
    meta: {
      title: '名校名企管理系统',
      isChildren: false
    },
    component: resolve => import('@/view/system/index').then(module => { resolve(module) }),
    redirect: '/system/deptInfo',
    children: [
      {
        path: 'deptInfo/:orgaId',
        name: 'deptInfo',
        meta: {
          title: '院系信息',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/deptInfo').then(module => { resolve(module) })
      },
      {
        path: 'userInfo/:orgaId',
        name: 'userInfo',
        meta: {
          title: '用户信息',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/userinfo').then(module => { resolve(module) })
      },
      {
        path: 'orgaSystem/:orgaId',
        name: 'orgaSystem',
        meta: {
          title: '机构管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/orgaSystem').then(module => { resolve(module) })
      },
      {
        path: 'toolSystem',
        name: 'toolSystem',
        meta: {
          title: '工具管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/toolSystem').then(module => { resolve(module) })
      },
      {
        path: 'toolsCategory',
        name: 'toolsCategory',
        meta: {
          title: '网站工具',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/toolsCategory').then(module => { resolve(module) })
      },
      {
        path: 'portalsHome/:orgaId',
        name: 'portalsHome',
        meta: {
          title: '首页',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysportals/home').then(module => { resolve(module) })
      },
      {
        path: 'portalsHomeAbout/:orgaId',
        name: 'portalsHomeAbout',
        meta: {
          title: 'HomeAbout',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysportals/homeAbout').then(module => { resolve(module) })
      },
      {
        path: 'portalsHomeEducation/:orgaId',
        name: 'portalsHomeEducation',
        meta: {
          title: 'portalsHomeEducation',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysportals/portalsHomeEducation').then(module => { resolve(module) })
      },
      {
        path: 'portalsTeachingQuality/:orgaId',
        name: 'portalsTeachingQuality',
        meta: {
          title: 'portalsTeachingQuality',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysportals/portalsTeachingQuality').then(module => { resolve(module) })
      },
      {
        path: 'portalsTool/:orgaId',
        name: 'portalsTool',
        meta: {
          title: 'portalsTool',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysportals/portalsTool').then(module => { resolve(module) })
      },
      {
        path: 'portalsNetwork/:orgaId',
        name: 'portalsNetwork',
        meta: {
          title: 'portalsNetwork',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysportals/portalsNetwork').then(module => { resolve(module) })
      },
      {
        path: 'portalsNews/:orgaId',
        name: 'portalsNews',
        meta: {
          title: 'portalsNews',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysportals/portalsNews').then(module => { resolve(module) })
      },
      {
        path: 'portalsCuntact/:orgaId',
        name: 'portalsCuntact',
        meta: {
          title: 'portalsCuntact',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysportals/portalsCuntact').then(module => { resolve(module) })
      },
      {
        path: 'VersionBacktracking/:orgaId',
        name: 'VersionBacktracking',
        meta: {
          title: '门户版本追溯',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysportals/VersionBacktracking').then(module => { resolve(module) })
      },
      {
        path: 'orgUserAuditing/:orgaId',
        name: 'orgUserAuditing',
        meta: {
          title: '机构人员审核数据',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysAuditing/orgUserAuditing').then(module => { resolve(module) })
      },
      {
        path: 'courseAuditing/:orgaId',
        name: 'courseAuditing',
        meta: {
          title: '机构课程审核',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysAuditing/courseAuditing').then(module => { resolve(module) })
      },
      {
        path: 'orgCourseAuditing',
        name: 'orgCourseAuditing',
        meta: {
          title: '机构课程审核(平台)',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysAuditing/orgCourseAuditing').then(module => { resolve(module) })
      },
      {
        path: 'platCourseAuditing',
        name: 'platCourseAuditing',
        meta: {
          title: '平台课程审核',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysAuditing/platCourseAuditing').then(module => { resolve(module) })
      },
      {
        path: 'regionApplyAuditing',
        name: 'regionApplyAuditing',
        meta: {
          title: '区域管理员审核',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysAuditing/regionApplyAuditing').then(module => { resolve(module) })
      },
      {
        path: 'platNewAuditing/:orgaId',
        name: 'platNewAuditing',
        meta: {
          title: '平台新闻审核',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysAuditing/platNewAuditing').then(module => { resolve(module) })
      },
      {
        path: 'platEventAuditing/:orgaId',
        name: 'platEventAuditing',
        meta: {
          title: '平台事件审核',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysAuditing/platEventAuditing').then(module => { resolve(module) })
      },
      {
        path: 'trainAuditing',
        name: 'trainAuditing',
        meta: {
          title: '培训管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysCredit/trainAuditing').then(module => { resolve(module) })
      },
      {
        path: 'trainModuleAuditing',
        name: 'trainModuleAuditing',
        meta: {
          title: '培训分类管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysCredit/trainModuleAuditing').then(module => { resolve(module) })
      },
      {
        path: 'creditAuditing',
        name: 'creditAuditing',
        meta: {
          title: '培训学时管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysCredit/creditAuditing').then(module => { resolve(module) })
      },
      {
        path: 'implementation',
        name: 'implementation',
        meta: {
          title: '项目实施及绩效',
          isChildren: false
        },
        component: resolve => import('@/view/system/test/implementation').then(module => { resolve(module) })
      },
      {
        path: 'trainRegistration',
        name: 'trainRegistration',
        meta: {
          title: '培训学时登记',
          isChildren: false
        },
        component: resolve => import('@/view/system/test/trainRegistration').then(module => { resolve(module) })
      },
      {
        path: 'implementationExcel',
        name: 'implementationExcel',
        meta: {
          title: '项目实施及绩效excel数据',
          isChildren: false
        },
        component: resolve => import('@/view/system/test/implementationExcel').then(module => { resolve(module) })
      },
      {
        path: 'courseRecommend',
        name: 'courseRecommend',
        meta: {
          title: '课程管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysCredit/courseRecommend').then(module => { resolve(module) })
      },
      {
        path: 'regionMemberManage',
        name: 'regionMemberManage',
        meta: {
          title: '区域成员管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManage/regionMemberManage').then(module => { resolve(module) })
      },
      {
        path: 'expertAuditing',
        name: 'expertAuditing',
        meta: {
          title: '专家管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManage/expertAuditing').then(module => { resolve(module) })
      },
      {
        path: 'trainNotice',
        name: 'trainNotice',
        meta: {
          title: '培训公告',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysCredit/trainNotice').then(module => { resolve(module) })
      },
      {
        path: 'classifyNotice',
        name: 'classifyNotice',
        meta: {
          title: '培训分类公告',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysCredit/classifyNotice').then(module => { resolve(module) })
      },
      {
        path: 'newQuestions',
        name: 'newQuestions',
        meta: {
          title: '常见问题',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysCredit/newQuestions').then(module => { resolve(module) })
      },
      {
        path: 'sysDistrict',
        name: 'sysDistrict',
        meta: {
          title: '区域管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysDistrict/sysDistrict').then(module => { resolve(module) })
      },
      {
        path: 'sysCreditDistrict',
        name: 'sysCreditDistrict',
        meta: {
          title: '区域学分管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysDistrict/sysCreditDistrict').then(module => { resolve(module) })
      },
      {
        path: 'sysWorkCount',
        name: 'sysWorkCount',
        meta: {
          title: '作业统计导出',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysDistrict/sysWorkCount').then(module => { resolve(module) })
      },
      {
        path: 'homePageExpert',
        name: 'homePageExpert',
        meta: {
          title: '首页专家管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManage/homePageExpert').then(module => { resolve(module) })
      },
      {
        path: 'courseTagManage',
        name: 'courseTagManage',
        meta: {
          title: '首页专家管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManage/courseTagManage').then(module => { resolve(module) })
      },
      {
        path: 'paraMeterDispose',
        name: 'paraMeterDispose',
        meta: {
          title: '参数配置',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManage/paraMeterDispose').then(module => { resolve(module) })
      },
      {
        path: 'learningStage',
        name: 'learningStage',
        meta: {
          title: '学习阶段管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManage/learningStage').then(module => { resolve(module) })
      },
      {
        path: 'operationTemplate',
        name: 'operationTemplate',
        meta: {
          title: '作业模板管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManage/operationTemplate').then(module => { resolve(module) })
      },
      {
        path: 'indexBannerConfig',
        name: 'indexBannerConfig',
        meta: {
          title: '首页轮播图设置',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManage/homeBanner').then(module => { resolve(module) })
      },
      {
        path: 'portalsCurriculum/:orgaId',
        name: 'portalsCurriculum',
        meta: {
          title: 'portalsCurriculum',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysportals/portalsCurriculum').then(module => { resolve(module) })
      },
      {
        path: 'myOrder/:orgaId',
        name: 'myOrder',
        meta: {
          title: '我的工单',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysOrder/myOrder').then(module => { resolve(module) })
      },
      {
        path: 'myOrderDetail/:orgaId',
        name: 'myOrderDetail',
        meta: {
          title: '工单详情',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysOrder/myOrderDetail').then(module => { resolve(module) })
      },
      {
        path: 'updateOrder/:orgaId',
        name: 'updateOrder',
        meta: {
          title: '工单提交',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysOrder/updateOrder').then(module => { resolve(module) })
      },
      {
        path: 'questionDetail/:orgaId',
        name: 'questionDetail',
        meta: {
          title: '工单详情',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysOrder/questionDetail').then(module => { resolve(module) })
      },
      {
        path: 'updateNewOrder/:orgaId',
        name: 'updateNewOrder',
        meta: {
          title: '创建工单',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysOrder/updateNewOrder').then(module => { resolve(module) })
      },
      {
        path: 'orderClass/:orgaId',
        name: 'orderClass',
        meta: {
          title: '工单分类',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysOrder/orderClass').then(module => { resolve(module) })
      },
      {
        path: 'orderReply/:orgaId',
        name: 'orderReply',
        meta: {
          title: '工单回复',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysOrder/orderReply').then(module => { resolve(module) })
      },
      {
        path: 'orderReplyDetail/:orgaId',
        name: 'orderReplyDetail',
        meta: {
          title: '工单回复详情',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysOrder/orderReplyDetail').then(module => { resolve(module) })
      },
      {
        path: 'commonProblem/:orgaId',
        name: 'commonProblem',
        meta: {
          title: '常见问题',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysOrder/commonProblem').then(module => { resolve(module) })
      },
      {
        path: 'educationEdit/:educationId',
        name: 'educationEdit',
        meta: {
          title: '学历编辑',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/educationEdit').then(module => { resolve(module) })
      },
      // {
      //   path: 'schoolIntro1',
      //   name: 'schoolIntro1',
      //   meta: {
      //     title: '学校/企业介绍',
      //     isChildren: false
      //   },
      //   component: resolve => import('@/view/system/sysManagement/schoolIntro').then(module => { resolve(module) })
      // },
      {
        path: 'schoolIntro/:orgaId',
        name: 'schoolIntro',
        meta: {
          title: '学校/企业介绍',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/University').then(module => { resolve(module) })
      },
      {
        path: 'news/:orgaId',
        name: 'sysnews',
        meta: {
          title: '资讯管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/news').then(module => { resolve(module) })
      },
      {
        path: 'events/:orgaId',
        name: 'sysevents',
        meta: {
          title: '事件管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/events').then(module => { resolve(module) })
      },
      {
        path: 'courses/:orgaId',
        name: 'syscourse',
        meta: {
          title: '课程管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/course').then(module => { resolve(module) })
      },
      {
        path: 'sysResource',
        name: 'sysResource',
        meta: {
          title: '资讯发布',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/sysResource').then(module => { resolve(module) })
      },
      {
        path: 'sysQualifications',
        name: 'sysQualifications',
        meta: {
          title: '学历管理',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/sysQualifications').then(module => { resolve(module) })
      },
      {
        path: 'registList',
        name: 'registList',
        meta: {
          title: '报名列表',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/registList').then(module => { resolve(module) })
      },
      {
        path: 'audit',
        name: 'audit',
        meta: {
          title: '审核',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/audit').then(module => { resolve(module) })
      },
      {
        path: 'registration',
        name: 'registration',
        meta: {
          title: '报名信息',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/registration').then(module => { resolve(module) })
      },
      {
        path: 'newDepartment',
        name: 'newDepartment',
        meta: {
          title: '新建院系',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/newDepartment').then(module => { resolve(module) })
      },
      {
        path: 'setEdu',
        name: 'setEdu',
        meta: {
          title: '学历创建编辑',
          isChildren: false
        },
        component: resolve => import('@/view/system/sysManagement/setEdu').then(module => { resolve(module) })
      },
      {
        path: 'dataQuery',
        name: 'dataQuery',
        meta: {
          title: '数据总览',
          isChildren: false
        },
        component: resolve => import('@/view/system/dataQuery/dataQuery').then(module => { resolve(module) })
      },
    ]
  },{
    path: '/obor',
    name: 'obor',
    meta: {
      title: '一带一路',
      isChildren: false
    },
    component: resolve => import('@/view/OBOR/OBOR').then(module => { resolve(module) }),
  },
  {
    path: '/trainingCourse',//培训课程
    name: 'trainingCourse',
    component: resolve => import('@/view/home/training/trainingCourse').then(module => { resolve(module) }),
    redirect: '/trainingCourse/index',
    children: [
      {
        path: 'index/:level/:trainId',
        name: 'index',
        meta: {
          title: '首页',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/trainingCourseindex').then(module => { resolve(module) })
      },
      {
        path: 'training',
        name: 'training',
        meta: {
          title: '强师行动大页面',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/training').then(module => { resolve(module) })
      },
      {
        path: 'details/:level/:trainId',
        name: 'details',
        meta: {
          title: '详情页',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/trainingCourseDetails').then(module => { resolve(module) })
      },
      {
        path: 'trainingCourselist/:level/:trainId',
        name: 'trainingCourselist',
        meta: {
          title: '课程中心大页面',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/trainingCourselist').then(module => { resolve(module) })
      },
      {
        path: 'trainingBoutiqueCourselist/:level/:trainId',
        name: 'trainingBoutiqueCourselist',
        meta: {
          title: '精品课程大页面',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/trainingBoutiqueCourselist').then(module => { resolve(module) })
      },
      {
        path: 'trainingExpert/:level/:trainId',
        name: 'trainingExpert',
        meta: {
          title: '专家风采大页面',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/trainingExpert').then(module => { resolve(module) })
      },
      {
        path: 'trainingNotice/:level/:trainId',
        name: 'trainingNotice',
        meta: {
          title: '专家公告大页面',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/trainingNotice').then(module => { resolve(module) })
      },
      {
        path: 'trainProjectList/:level/:trainId',
        name: 'trainProjectList',
        meta: {
          title: '培训项目大页面',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/trainProjectList').then(module => { resolve(module) })
      },
      {
        path: 'trainingDetails/:level/:trainId/:id',
        name: 'trainingDetails',
        meta: {
          title: '专家公告详情页',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/trainingDetails').then(module => { resolve(module) })
      },
      {
        path: 'trainingExpertList/:level/:trainId/:id',
        name: 'trainingExpertList',
        meta: {
          title: '专家详情页',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/trainingExpertList').then(module => { resolve(module) })
      },
      {
        path: 'trainingHelpCenter/:level/:trainId',
        name: 'trainingHelpCenter',
        meta: {
          title: '帮助中心',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/trainingHelpCenter').then(module => { resolve(module) })
      },
      {
        path: 'trainingStats/:level/:trainId',
        name: 'trainingStats',
        meta: {
          title: '数据统计',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/trainingStats').then(module => { resolve(module) })
      },
      {
        path: 'trainingProjectStats/:level/:trainId',
        name: 'trainingProjectStats',
        meta: {
          title: '数据统计',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/trainingProjectStats').then(module => { resolve(module) })
      },
      {
        path: 'goGoodList/:level/:trainId',
        name: 'goGoodList',
        meta: {
          title: '优秀表扬',
          isChildren: false
        },
        component: resolve => import('@/view/home/training/goGoodList').then(module => { resolve(module) })
      },
    ],
  },
  {
    path: '/dataPresentation',//培训课程数据展示
    name: 'dataPresentation',
    component: resolve => import('@/view/home/training/dataPresentation').then(module => { resolve(module) }),
  },
  {
    path: '/me',//培训课程
    name: 'me',
    component: resolve => import('@/view/person/me').then(module => { resolve(module) }),
    redirect: '/me/index',
    children: [
      {
        path: 'index/:userId',
        name: 'index',
        meta: {
          title: '首页',
          isChildren: false
        },
        component: resolve => import('@/view/person/pages/myStudy').then(module => { resolve(module) })
      },
    ]
  },
  {
    path : '/areaManager',
    name : 'areaManager',
    component: resolve => import('@/view/home/training/apply/areaManager').then(module => { resolve(module) })
  },
  {
    path : '/bigDataBoard',
    name : 'bigDataBoard',
    component: resolve => import('@/view/bigDataBoard/index').then(module => { resolve(module) }),
    redirect: '/bigDataBoard/home',
    children: [
      {
        path: 'home',
        name: 'home',
        meta: {
          title: '首页',
          isChildren: false
        },
        component: resolve => import('@/view/bigDataBoard/home').then(module => { resolve(module) })
      },{
        path: 'subjectList',
        name: 'subjectList',
        meta: {
          title: '学科列表',
          isChildren: false
        },
        component: resolve => import('@/view/bigDataBoard/subjectList').then(module => { resolve(module) })
      },{
        path: 'classTeacherList',
        name: 'classTeacherList',
        meta: {
          title: '班主任列表',
          isChildren: false
        },
        component: resolve => import('@/view/bigDataBoard/classTeacherList').then(module => { resolve(module) })
      },
    ]
  },
  {
    path: "/pySubjectBigData",
    name: "/pySubjectBigData",
    meta: {
      title: "大数据平台"
    },
    component: resolve => import("@/view/bigDataBoard2/bigData2").then(module => { resolve(module)})
  },
]

export const asyncRouterMap = []

const createRouter = () => new Router({
  mode: 'history',
  // routes: [constantRouterMap, asyncRouterMap]
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js